import { Box, Typography, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import eu from "../assets/images/eu.png";

export default function Footer() {
  const { t } = useTranslation("footer");
  return (
    <Box sx={{ width: "100%", textAlign: "center" }}>
      <Divider />
      <Typography
        variant="subtitle2"
        sx={{
          margin: "20px",
          fontSize: "12px",
          fontWeight: "300",
        }}
      >
        <img src={eu} width="20px" alt="EU flag" />{" "}
        {t("fundingDisclaimer", { number: "101104777" })}
      </Typography>
    </Box>
  );
}
